import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanMatch, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MembersAccessService implements CanMatch, CanActivate {

  constructor(
    private _route: Router,
    private _auth: AuthService,
    private _notifications: NotificationService
  ) { }
  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    throw new Error('Method not implemented.');
  }

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | UrlTree | boolean {
    let auth = this._auth.isAuthenticated();
    if (!auth) {
      this._notifications.stopAllPolling();
      this._route.navigate(['public/sign/login']);
    }
    return auth;
  }


}
